/*
  Runtime configuration. Self-hosted installs (Helm chart) set API_URL on the
  frontend container; its entrypoint writes /config.js, which index.html loads
  before the app. Hosted builds leave it empty and use the API URL baked in at
  build time (REACT_APP_BACKEND_URL).
*/
const runtime = (typeof window !== 'undefined' && window.__APP_CONFIG__) || {};

export const BACKEND_URL = String(runtime.backendUrl || process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');
